import { PageIcons } from "./page-icons.ts";

/**
 * The game page's one icon store (ADR-111), as `PAGE_MOTION` is its one reduced motion setting: the pointer and its
 * atlas, loaded once when the asset base is known and held for the page's life. The HUD's places draw from it through
 * their context, and the canvas's emoji over characters (`world-ui/emoji/`) take its decoded atlas as a texture, so the
 * atlas is fetched once for both. The gallery makes its own (`gallery/icons.ts`).
 */
export const PAGE_ICONS = new PageIcons();
